import { Component, Input, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { IHistoryView } from '../history.model';
import { HistoryComponent } from '../history.component';
import { inOutAnimation } from 'src/app/common/animations';

@Component({
    selector: 'app-history-view',
    templateUrl: './history-view.component.html',
    styleUrls: ['./history-view.component.scss'],
    animations: [inOutAnimation],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HistoryViewComponent implements OnInit {
  @Input() historyView: IHistoryView;
  @ViewChild(HistoryComponent) historyComponent: HistoryComponent;
  constructor() {}

  ngOnInit(): void {}

  render() {
    if (this.historyView) this.historyComponent.render();
  }
}
